<template>
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99935 18.8334C14.5827 18.8334 18.3327 15.0834 18.3327 10.5C18.3327 5.91669 14.5827 2.16669 9.99935 2.16669C5.41602 2.16669 1.66602 5.91669 1.66602 10.5C1.66602 15.0834 5.41602 18.8334 9.99935 18.8334Z" stroke="#FF8300" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 7.16669V11.3334" stroke="#FF8300" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.99609 13.8333H10.0036" stroke="#FF8300" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>